import React from 'react'
import IcoIconContainer from '../../../Components/Icons/IcoIcon'

export default function IcoIcon() {
  return (
    <div className='page-body'>
        <IcoIconContainer/>
    </div>
  )
}
